import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Account as AccountService } from '@redshelf/redshelf-data';
import {
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { useToast } from '@redshelf/redshelf-ui';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const useStyles = makeStyles((theme) => {
  return {
    avatar: {
      marginRight: theme.spacing(1),
    },
    popover: {
      width: 200,
    },
  };
});

const accountService = new AccountService();

const Account = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const ref = useRef(null);

  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { enqueueToast } = useToast();

  const handleLogout = async () => {
    handleClose();
    const onError = () => {
      enqueueToast(<span>We were unable to process your login request</span>, {
        title: 'Error Logging Out',
        variant: 'error',
      });
    };
    try {
      const success = await accountService.logout();
      if (success) {
        // Fallback in case accountService does not navigate
        navigate('/');
      } else {
        onError();
      }
    } catch (e) {
      onError();
    }
  };

  const { user } = accountService;

  return (
    <React.Fragment>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <AccountCircleIcon className={classes.avatar} />
        <Hidden smDown>
          <Typography>{`${user?.first_name} ${user?.last_name}`}</Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default Account;
